import * as React from 'react';
import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuGroup,
    MenuDivider,
    MenuOptionGroup,
    MenuItemOption
} from '@chakra-ui/core';
import { Box } from '../box';
import { Button } from '../button';
import { isLight } from '../../utils/colors';

type DropDownMenuProps = any & {
	menuItems: (string | { label: string, link: string })[]
	variantColor?: string
	menuVariantColor?: string,
	defaultActiveIndex?: number
}

type DropDownMenuButtonProps = any & {}

type DropDownMenuLinkProps = any & {}

const DropDownMenuButton: React.FC<DropDownMenuButtonProps> = React.forwardRef((props, ref: React.Ref<HTMLButtonElement>) => <MenuButton ref={ref} as={Button} {...props} />);

const DropDownMenuLink: React.FC<DropDownMenuLinkProps> = React.forwardRef((props, ref: React.Ref<HTMLButtonElement>) => <MenuItem ref={ref} as="a" {...props} />);

const DropDownMenu: React.FC<DropDownMenuProps> = (props: DropDownMenuProps): React.ReactElement => {
    const {
        menuItems,
        bg,
        menuBg,
        defaultActiveIndex,
        ...rest
    } = props;

    const [isOpen, setIsOpen] = React.useState(false);
    const [activeLabel, setActiveLabel] = React.useState('');

    React.useEffect(() => {
        const item = menuItems[defaultActiveIndex];
        setActiveLabel(item.label || item);
    }, []);

    const menuItemStyle = {
        fontSize: 'lg',
        fontWeight: 600,
        color: isLight(menuBg) ? 'text.dark.primary' : 'text.light.primary'
    };

    const items = menuItems.map((item, index) => {
        if (typeof item === 'string') {
            return (
                <MenuItem
                    key={`menuitem-${index}`}
                    onClick={() => setActiveLabel(item)}
                    {...menuItemStyle}
                >
                    {item}
                </MenuItem>
            );
        } if (typeof item === 'object' && item.label && item.link) {
            return (
                <DropDownMenuLink
                    key={`menuitem-${index}`}
                    as="a"
                    href={item.link}
                    onClick={() => setActiveLabel(item.label)}
                    {...menuItemStyle}
                >
                    {item.label}
                </DropDownMenuLink>
            );
        }
    });

    return (
        <Menu
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            defaultActiveIndex={defaultActiveIndex}
            {...rest}
        >
            <Box position="relative">
                <DropDownMenuButton bg={bg} rightIcon="chevron-down" display={isOpen ? 'none' : 'block'}>
                    {activeLabel}
                </DropDownMenuButton>
                <MenuList bg={menuBg} position="absolute">
                    {items}
                </MenuList>
            </Box>
        </Menu>
    );
};

DropDownMenu.defaultProps = {
    defaultActiveIndex: 0
};

export default DropDownMenu;
